import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {SecurityContext} from "@angular/core";

export class RichTextSanitizerUtil {
    static sanitizeText(htmlString: string, sanitizer: DomSanitizer): SafeHtml {
        return sanitizer.bypassSecurityTrustHtml(htmlString);
    }

    static getSanitizedHtml(htmlString: string, sanitizer: DomSanitizer): string {
        return sanitizer.sanitize(SecurityContext.HTML, htmlString);
    }

    static sanitizeTextString(text: string, sanitizer: DomSanitizer): SafeHtml {
        text = '<p>' + text.replace(/\n/g, '<br>') + '</p>';
        return RichTextSanitizerUtil.sanitizeText(text, sanitizer);
    }
}
